// import { VALUE_POSITION_TYPE } from "@/app/report/common/constants" TODO unused 제거
import { SectionScatterChart } from "@/app/report/common/constructor"
import PrintableSection from "./PrintableSection"
import ScatterChart from "../../chart/pdf/ScatterChart"
import { useTranslateMetricKey } from "@/hooks/metric/useTranslateKeyHook"

export default function PrintableScatterSection({
  data,
  scaleRatio,
}: {
  data: SectionScatterChart
  scaleRatio?: number
}) {
  const translateKey = useTranslateMetricKey()

  // axis.name이 metric.xxx 형태면 key 추출해서 번역, 아니면 이미 번역된 값이므로 그대로 사용
  const getAxisName = (name: string | undefined) => {
    if (!name) return ""
    if (name.includes("metric.")) {
      return translateKey(name.split("metric.")[1]) || name
    }
    return name
  }

  return (
    <div className="renewal-pdf-container preview ScatterChartPdfCont">
      {data.charts.map((chart, index) => (
        <PrintableSection
          sectionTitle={getAxisName(chart.axisX.name) + " / " + getAxisName(chart.axisY.name)}
          scaleRatio={scaleRatio}
          key={index}
          totalItemCount={data.charts.length}
          currentItemCount={index + 1}>
          <ScatterChart chartData={chart} loading={false} />
        </PrintableSection>
      ))}
    </div>
  )
}
